import React from 'react'
import {
  Alert,
  Form,
  Input,
  ModalFooterContainer,
  ModalCancelButton,
  ModalSubmitButton,
  message,
} from 'admin-web-ui'
import { Store } from 'rc-field-form/lib/interface'
import { ApolloClient } from '@apollo/client'
import { useAsyncFn } from 'react-use'
import { addSafetyNetPackageName } from './add-safety-net-package-name'

interface Props {
  projectClient: ApolloClient<unknown>
  onSuccess: () => void
  onCancel: () => void
}

export const PackageNameWhitelistingForm: React.FC<Props> = (props) => {
  const { projectClient, onCancel, onSuccess } = props
  const [submitState, handleSubmit] = useAsyncFn(
    async (values?: Store) => {
      if (!values) {
        return undefined
      }

      await addSafetyNetPackageName(projectClient, values.packageName)

      message.success('Package name added!')
      onSuccess()
    },
    [projectClient],
  )

  return (
    <Form onFinish={handleSubmit} layout="vertical">
      <Form.Item
        name="packageName"
        label="Package Name"
        rules={[{ required: true, message: 'Please provide a package name.' }]}
      >
        <Input type="text" placeholder="Package name" />
      </Form.Item>
      {submitState.error && (
        <Alert
          type="error"
          message="There was an error adding your package name. Please try again."
        />
      )}
      <ModalFooterContainer>
        <ModalCancelButton
          onClick={onCancel}
          className="automation-PackageNameWhitelistingFormCancelButton"
          type="default"
          shape="round"
        >
          Cancel
        </ModalCancelButton>
        <ModalSubmitButton
          className="automation-PackageNameWhitelistingFormSubmitButton"
          type="primary"
          htmlType="submit"
          loading={submitState.loading}
          shape="round"
        >
          Add
        </ModalSubmitButton>
      </ModalFooterContainer>
    </Form>
  )
}
